import { useQuery } from 'react-query';

// our api
import localAxiosInstance from 'services/API/LocalAPI';

// our query keys
import { KEY_ACTIONS } from 'shared/query-keys';

// our endpoints
import { keyActionsUrl } from 'shared/api-urls';

// our constants
import { DEFAULT_STALE_TIME_FIVE_MINUTES } from 'shared/constants';

function useGetKeyActions(select = (data) => data, queryParams = {}) {
	return useQuery(
		[KEY_ACTIONS, queryParams?.status ?? ''],
		async () => {
			const response = await localAxiosInstance.get(keyActionsUrl, {
				params: queryParams
			});
			return response.data;
		},
		{
			staleTime: DEFAULT_STALE_TIME_FIVE_MINUTES,
			select
		}
	);
}

export default useGetKeyActions;
